/**
 * Forgot Password Form Validation Schema
 * Zod schema for validating forgot password form data
 */

import { z } from 'zod';

/**
 * Forgot password form validation schema
 */
export const forgotPasswordSchema = z.object({
  email: z.string().min(1, 'Email is required').email('Please enter a valid email address'),
});

/**
 * TypeScript type inferred from schema
 */
export type ForgotPasswordFormData = z.infer<typeof forgotPasswordSchema>;

/**
 * Default values for the forgot password form
 */
export const forgotPasswordFormDefaults: ForgotPasswordFormData = {
  email: '',
};
